/*
* Copyright (c) 2023 SHYFTBASE INC.
* Author: SHYFTBASE INC.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import locales from './locales/locales'
import LanguageDetector from 'i18next-browser-languagedetector'

// Define supported languages
const supportedLngs = ['en', 'de', 'nl', 'fr', 'es']

const resources = {
  en: {
    translation:  locales.en, 
  },
  de: {
    translation:  locales.de, 
  },
  nl: {
    translation:  locales.nl, 
  },
  fr: {
    translation:  locales.fr, 
  },
  es: {
    translation:  locales.es, 
  }
}

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        fallbackLng: 'en',
        supportedLngs,
        nonExplicitSupportedLngs: false,
        load: 'languageOnly',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
          escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            checkWhitelist: true
        }
    })

export default i18n